export enum SmoEnvironment {
  capKingdom = 'cap_kingdom',
  cascadeKingdom = 'cascade_kingdom',
  sandKingdomDay = 'sand_kingdom_day',
  sandKingdomNight = 'sand_kingdom_night',
  lakeKingdom = 'lake_kingdom',
  woodedKingdom = 'wooded_kingdom',
  cloudKingdom = 'cloud_kingdom',
  lostKingdom = 'lost_kingdom',
  metroKingdomDay = 'metro_kingdom_day',
  metroKingdomNight = 'metro_kingdom_night',
  snowKingdomDay = 'snow_kingdom_day',
  snowKingdomNight = 'snow_kingdom_night',
  seasideKingdom = 'seaside_kingdom',
  luncheonKingdom = 'luncheon_kingdom',
  ruinedKingdom = 'ruined_kingdom',
  bowserKingdom = 'bowser_kingdom',
  mushroomKingdomOutside = 'mushroom_kingdom_outside',
  mushroomKingdomCastle = 'mushroom_kingdom_castle',
  moonKingdomInside = 'moon_kingdom_inside',
  moonKingdomOutside = 'moon_kingdom_outside',
  store = 'store',
  none = 'Negative'
}
